import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { SeparatorLine } from '../../../../components/SeparatorLine/SeparatorLine';
import { getOrderDescription } from '../../../../helpers/order';
import { useServiceDate } from '../../../../hooks/useServiceDate';
import { useLanguage } from '../../../../locale/useLanguage';
import { Order } from '../../../../models';
import { Routes } from '../../../../routes/types';

import './OrderRow.css';

type OrderRowProps = {
  order: Order;
};

export const OrderRow: React.FC<OrderRowProps> = ({ order }) => {
  const [t] = useLanguage();
  const history = useHistory();

  const orderDescription = getOrderDescription(
    order.status,
    order.suspended,
    t
  );
  const serviceDate = useServiceDate(order);

  const goToOrderHelp = useCallback(() => {
    history.push(Routes.Help.replace(':mlkId', order.opaqueId));
  }, [history, order.opaqueId]);

  return (
    <>
      <div className="order-row--container">
        <div className="order-row--shipper-row">
          <p className="order-row--shipper-name">
            {order.shipper.alias || order.shipper.name}
          </p>
          <p className="order-row--date">
            {serviceDate?.format('DD MMM YYYY')}
          </p>
        </div>
        <h3 className="order-row--tracking-code">{order.shipperOrderCode}</h3>
        <p>{orderDescription}</p>
        <a role="link" onClick={goToOrderHelp} className="link clickable">
          {t('searchOrder.requestHelp')}
        </a>
      </div>
      <SeparatorLine />
    </>
  );
};
